import { SELECTIVE_SHARING } from '../../../../../../../modules/audiences/AudienceForm/constants';
import type { FormSegment } from '../../../../../../../modules/audiences/AudienceForm/types';
import { hasSegmentFee } from '../../../../../../../modules/audiences/AudienceForm/utils/hasSegmentFee';
import type { BaseBasicInfoParams, BasicInfoProps } from '../drawer/components/types';

type RegularSegmentParams = BaseBasicInfoParams & {
  segment: FormSegment;
};

export type LookalikeSegmentParams = BaseBasicInfoParams & {
  isSelectedList: boolean;
  lookalikeReachRange: string | null;
  isSeed?: boolean;
};

export const createBasicInfoPropsFromSegment = ({
  segment,
  id,
  reach,
  displayReach,
  category,
  organizationName,
  providerName,
  isPredefinedSegment,
}: RegularSegmentParams): BasicInfoProps => {
  const baseProps: BaseBasicInfoParams = {
    id,
    reach,
    displayReach,
    category,
    organizationName,
    providerName,
    isPredefinedSegment,
  };

  const chargesFee = segment.sellable || segment.sharing_type === SELECTIVE_SHARING;

  if (chargesFee && hasSegmentFee(segment.price_pom, segment.price_cpm)) {
    return {
      ...baseProps,
      priced: true,
      isLookalike: false,
      pricePom: Number(segment.price_pom) || 0,
      priceCpm: Number(segment.price_cpm) || 0,
    };
  }

  return {
    ...baseProps,
    priced: false,
    isLookalike: false,
  };
};

export const createBasicInfoPropsFromLookalike = (props: LookalikeSegmentParams): BasicInfoProps => {
  return {
    ...props,
    isLookalike: true,
    priced: false,
  };
};
